import React from "react";
import { Star, Phone, Clock, MapPin, CircleCheck, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourLocalNorfolkAutoLocksmith() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="your-local-norfolk-auto-locksmith" ref={sectionRef} className="relative w-full overflow-hidden bg-slate-950 text-slate-50 py-16 lg:py-24 xl:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none">
        <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(to right, #334155 1px, transparent 1px), linear-gradient(to bottom, #334155 1px, transparent 1px)`,
        backgroundSize: '40px 40px'
      }} />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-slate-950/50" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8 items-center">
          
          {}
          <div className={`lg:col-span-7 flex flex-col gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="flex flex-wrap gap-3 items-center">
              <Badge variant="outline" className="border-yellow-500/50 text-yellow-400 bg-yellow-500/10 px-3 py-1 text-sm backdrop-blur-sm">
                <Clock className="w-3.5 h-3.5 mr-1.5" />
                30-Minute Response Time
              </Badge>
              <Badge variant="secondary" className="bg-slate-800 text-slate-300 border-slate-700">
                <MapPin className="w-3.5 h-3.5 mr-1.5" />
                Serving Norfolk & East Anglia
              </Badge>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight leading-[1.1]">
              Stranded in <span className="text-white">Norfolk?</span>
              <br />
              <span className="text-yellow-400 drop-shadow-[0_0_15px_rgba(250,204,21,0.3)]">
                AngliaKeys
              </span> is here.
            </h1>

            <p className="text-lg md:text-xl text-slate-400 max-w-2xl leading-relaxed">
              Professional car auto locksmith dedicated to rapid assistance. 
              We specialise in lost keys, spare key duplication, and on‑site lockout resolutions 
              using advanced key‑cutting technology.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <Button asChild size="lg" className="bg-yellow-500 hover:bg-yellow-400 text-slate-950 font-bold text-base h-14 px-8 shadow-[0_0_20px_rgba(234,179,8,0.2)] hover:shadow-[0_0_30px_rgba(234,179,8,0.4)] transition-all">
                <Link to="tel:07700123456">
                  <Phone className="w-5 h-5 mr-2" />
                  Call Now: 07700 123456
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="border-slate-700 text-slate-200 hover:bg-slate-800 hover:text-white h-14 px-8 backdrop-blur-sm bg-slate-900/50">
                <Link to="/LostKeysPage">
                  Get a Quote
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-8 flex items-center gap-4 p-4 rounded-xl bg-slate-900/60 border border-slate-800 backdrop-blur-md w-fit">
              <div className="bg-[#00b67a] p-1.5 rounded-sm">
                <Star className="w-6 h-6 text-white fill-white" />
              </div>
              <div>
                <div className="flex items-center gap-1">
                  <span className="font-bold text-white">Trustpilot</span>
                  <div className="flex gap-0.5">
                    {[1, 2, 3, 4, 5].map((star, i) => <div key={i} data-index={i} className="bg-[#00b67a] w-4 h-4 flex items-center justify-center rounded-[1px]">
                        <Star className="w-2.5 h-2.5 text-white fill-white" />
                      </div>)}
                  </div>
                </div>
                <p className="text-xs text-slate-400 mt-0.5">
                  Rated <span className="font-semibold text-slate-200">Excellent</span> by local motorists
                </p>
              </div>
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 relative h-[500px] lg:h-[600px] w-full flex items-center justify-center transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            {}
            <div className="absolute inset-0 rounded-3xl overflow-hidden border border-slate-800 bg-slate-900">
              <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/norfolk_roadside_blurred.png)] bg-cover bg-center opacity-40 blur-sm scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" />
            </div>

            {}
            <div className="relative z-10 w-full max-w-md transform hover:scale-105 transition-transform duration-500">
              <div className="absolute -inset-4 bg-yellow-500/20 blur-3xl rounded-full opacity-50 animate-pulse" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/modern_key_fob_programming.png" alt="Modern car key fob being programmed" className="w-full h-auto drop-shadow-2xl relative z-10" />
              
              {}
              <div className="absolute -bottom-6 -right-6 bg-slate-900/90 backdrop-blur-xl border border-slate-700 p-4 rounded-xl shadow-2xl max-w-[200px]">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                  <span className="text-xs font-mono text-green-400">SYSTEM ACTIVE</span>
                </div>
                <div className="space-y-1">
                  {['Key Programming', 'Transponder Chip', 'Remote Sync'].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-2 text-xs text-slate-300">
                      <CircleCheck className="w-3 h-3 text-yellow-500" />
                      {item}
                    </div>)}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}